const STORAGE_KEY = 'caddiesight.mobileReturn';
const MEMBERSHIP_COMPLETE_URL = 'caddiesight://membership-complete';
const DEV_MEMBERSHIP_COMPLETE_URL = 'caddiesight-dev://membership-complete';

export const validateMobileReturn = (value: string | null): string | null => {
  if (!value) return null;
  try {
    const url = new URL(value);
    if (url.host !== 'membership-complete') return null;
    if (url.protocol === 'caddiesight:') return MEMBERSHIP_COMPLETE_URL;
    if (url.protocol === 'caddiesight-dev:') return DEV_MEMBERSHIP_COMPLETE_URL;
    return null;
  } catch {
    return null;
  }
};

export const rememberMobileReturn = (value: string | null): void => {
  const validated = validateMobileReturn(value);
  if (validated) sessionStorage.setItem(STORAGE_KEY, validated);
};

export const completeMobileReturn = (value: string | null = null, useStoredFallback = true): boolean => {
  const target = validateMobileReturn(value)
    ?? (useStoredFallback ? validateMobileReturn(sessionStorage.getItem(STORAGE_KEY)) : null);
  if (!target) return false;
  sessionStorage.removeItem(STORAGE_KEY);
  window.location.assign(target);
  return true;
};
